module.exports = __webpack_public_path__ + "static/media/trigger_soundi 6-2-Audio 1.d0ff7cf7.mp3";